import { useCallback, useEffect, useState } from "react";

type Props = {
  query: string | "(max-width: 768px)"; // 注意：一定要使用括号包裹，否则无法实时监听
}

const useMediaQuery = (props: Props) => {
  const {
    query,
  } = props;

  const [isMatch, setIsMatch] = useState<boolean | undefined>(window?.matchMedia(query)?.matches??false);

  const listener = useCallback((mql: any) => {
    setIsMatch(mql.matches);
  }, []);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query); 
    setIsMatch(mediaQueryList.matches);
    
    mediaQueryList.addEventListener("change", listener);

    return () => {
      mediaQueryList.removeEventListener("change", listener);
    };
  }, [query, listener]);

  return isMatch;
};

export default useMediaQuery;